import React from "react";
import PT from "prop-types";
import { Link, theme } from "@icg360/design-system";
import { styled } from "styled-components";

import { LiveChatRoot } from "../root/live-chat";
import store from "../../store";
import { SCREEN_WIDTH } from "../quote-constants";

import { StatusIo } from "./components/status-io";
import * as FOOTER from "./constants";

const StyledFooter = styled.footer`
  flex: 0;
  width: 100%;
  padding: 0 15px;
  height: 51px;
  border-top: 1px solid ${theme.colors.border.default};
  background: #f1f1f1;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.colors.text.default};
  a {
    color: ${theme.colors.text.default};
    text-decoration: underline;
  }
  > .wrap {
    position: relative;
    margin: 0 auto;
    padding: 18px 140px 10px;
    min-height: 50px;
  }
  .logo {
    position: absolute;
    left: -12px;
    top: 7px;
    width: 139px;
    height: 36px;
    background: url("/assets/svg/logo-horz-full-color.svg") no-repeat left
      center / contain;
  }
  .content {
    text-align: center;
  }
  .group {
    position: relative;
    padding: 0 3px 0 7px;
    white-space: nowrap;
  }
  .group + .group::before {
    content: "";
    position: absolute;
    left: 0;
    top: 1px;
    height: 10px;
    width: 1px;
    background: ${theme.colors.border.control};
  }
  .ipc {
    position: absolute;
    right: 30px;
    top: 8px;
    > a {
      display: none;
    }
  }
  .livechat {
    position: absolute;
    right: 5px;
    top: 8px;
    > a > img {
      width: 134px;
      height: 33px;
    }
  }
  @media (min-width: 1100px) {
    .group {
      padding: 0 10px 0 14px;
    }
  }
  #live-chat-8x8 {
    display: none;
  }
`;

const StyledFooterWrap = styled.div`
  max-width: ${SCREEN_WIDTH.FULL};
`;

export const Footer = ({ loggedIn = true }: { loggedIn?: boolean }) => {
  return (
    <StyledFooter data-bdd="ap-footer">
      <StyledFooterWrap className="wrap footer-wrap">
        <div className="logo"></div>
        <div className="content">
          <span className="group">
            &copy;
            {new Date().getFullYear()}
            <span id="copyright-holder">&nbsp;{FOOTER.COPYRIGHT_HOLDER}</span>
          </span>
          <span className="group">
            Version{" "}
            <code title={CONFIG.version.description}>
              {CONFIG.version.label}
            </code>
          </span>
          <span className="group">
            <Link
              data-track="Footer: Terms"
              href={FOOTER.TERMS_OF_SERVICE_URL}
              target="_blank"
            >
              Terms
            </Link>
          </span>
          <span className="group">
            <Link
              data-track="Footer: Privacy Policy"
              href={FOOTER.PRIVACY_POLICY_URL}
              target="_blank"
            >
              Privacy
            </Link>
          </span>
          <span className="group">
            <Link
              data-track="Footer: Support"
              href={FOOTER.SUPPORT_URL}
              target="_blank"
            >
              Support
            </Link>
          </span>
          <StatusIo />
        </div>
        <div id="live-chat-8x8"></div>
        {loggedIn && <LiveChatRoot store={store} />}
      </StyledFooterWrap>
    </StyledFooter>
  );
};

Footer.propTypes = {
  loggedIn: PT.bool
};
